export default __webpack_public_path__ + "static/media/bootstrap.6e92775c.svg";